import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material';
import { RunwayService } from '../service/runway.service';
import { EditAreaObstacleComponent } from '../edit-area-obstacle/edit-area-obstacle.component';

@Component({
  selector: 'app-delete-area-obstacle',
  templateUrl: './delete-area-obstacle.component.html',
  styleUrls: ['./delete-area-obstacle.component.scss']
})
export class DeleteAreaObstacleComponent implements OnInit {
  obstalceId: number;
  airportId: number;
  isLoading = false;

  constructor(private _matDialogRef: MatDialogRef<EditAreaObstacleComponent>,
              @Inject(MAT_DIALOG_DATA) data,
              private _runwayService: RunwayService) {
    this.obstalceId = data.obstacleId;
    this.airportId = data.airportId;
  }

  ngOnInit() {
    this._matDialogRef.backdropClick().subscribe(() => {
      this.close({cancelBtnClicked: true});
    });
  }

  close(data: any) {
    this._matDialogRef.close(data);
  }

  async delete() {
    try {
      this.isLoading = true;
      await this._runwayService.deleteObstacle(this.airportId, this.obstalceId);
      this.isLoading = false;
      this.close({success: true, obstacleId: this.obstalceId});
    } catch (e) {
      this.close({success: false, error: e});
    }
  }

  cancel () {
    this.close({cancelBtnClicked: true});
  }
}
